import React from 'react';

import TimelineItem from './TimelineItem';

import { TimelineGroupProps } from '../../types/leadActivity';
import { formatDisplayDate } from '../../utils/common';

const TimelineGroup = React.memo<TimelineGroupProps>(
  ({ date, items, groupIndex, totalGroups }) => (
    <div>
      <div className="mb-4 flex justify-start">
        <span className="text-base font-medium text-gray-700">
          {formatDisplayDate(date)}
        </span>
      </div>

      <div className="space-y-0">
        {items.map((item, itemIndex) => {
          const isLast =
            itemIndex === items.length - 1 && groupIndex === totalGroups - 1;

          return (
            <TimelineItem
              key={`${item.entity}-${item.timestamp}`}
              item={item}
              isLast={isLast}
            />
          );
        })}
      </div>
    </div>
  )
);

export default TimelineGroup;
